var _isLocalStorageAvailable = false;

try {
    localStorage.getItem('test');
    _isLocalStorageAvailable = true;
} catch (e) {
    _isLocalStorageAvailable = false;
}

var _isSessionStorageAvailable = false;

try {
    sessionStorage.getItem('test');
    _isSessionStorageAvailable = true;
} catch (e) {
    _isSessionStorageAvailable = false;
}

export const isSessionStorageAvailable = _isSessionStorageAvailable;
export const isLocalStorageAvailable = _isLocalStorageAvailable;